import { SafeEventEmitterProvider } from "@web3auth/base";
import ethProvider from "./ethProvider";
import solanaProvider from "./solanaProvider";

export interface IWalletProvider {
  getAccounts: () => Promise<any>;
  getBalance: () => Promise<any>;
  signMessage: (message: string) => Promise<any>;
  signV4Message: () => Promise<any>;
  getChain: () => Promise<string>;
  getChainId: () => Promise<number>;
  personalSign: (from: string, msg: string) => Promise<any>;
  getEnsByAddress: (address?: string) => Promise<any>;
}

export const getWalletProvider = (chain: string, provider: SafeEventEmitterProvider, uiConsole: any): IWalletProvider => {
  if (chain === "solana") {
    return solanaProvider(provider, uiConsole);
  }
  return ethProvider(provider, uiConsole);
};
